export type ProfilesTab = 'students' | 'environment';

export interface ProfilesTabConfig {
  id: ProfilesTab;
  label: string;
  href?: string;
}

export const profilesTabsConfig: ProfilesTabConfig[] = [
  { id: 'students', label: 'Students' },
  { id: 'environment', label: 'Environment' },
];

export const getProfilesTabHref = (tab: ProfilesTab): string => {
  return `#/app/profiles/${tab}`;
};

export const getProfilesTabsWithHrefs = (currentTab: ProfilesTab): ProfilesTabConfig[] => {
  return profilesTabsConfig.map(tab => ({
    ...tab,
    href: tab.id === currentTab ? undefined : getProfilesTabHref(tab.id)
  }));
};

export const isValidProfilesTab = (tab: string): tab is ProfilesTab => {
  return ['students', 'environment'].includes(tab);
};

